// ── View Switcher Component ──

const VIEWS = [
  {
    key: 'kanban',
    label: 'Kanban',
    icon: `<svg viewBox="0 0 24 24"><rect x="3" y="3" width="5" height="18" rx="1"/><rect x="10" y="3" width="5" height="12" rx="1"/><rect x="17" y="3" width="5" height="15" rx="1"/></svg>`,
  },
  {
    key: 'sprint',
    label: 'Sprint Board',
    icon: `<svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="4" rx="1"/><rect x="3" y="10" width="18" height="4" rx="1"/><rect x="3" y="17" width="18" height="4" rx="1"/></svg>`,
  },
];

// `groupLabelSingular` (C1395) — overrides the 'Sprint Board' tooltip's noun for the
// 'sprint' view key. Rendered before the project fetch resolves in board.js's
// boardPage() (the header HTML goes up before the page-load Promise.all does), so board.js
// refreshes this button's title live once it does — same pattern it already uses for
// #manage-sprints-btn's label.
export function renderViewSwitcher(activeView, groupLabelSingular = 'Sprint') {
  return `<div class="view-switcher">${VIEWS.map(v => {
    const title = v.key === 'sprint' ? `${groupLabelSingular} Board` : v.label;
    return `<button class="view-switcher-btn ${v.key === activeView ? 'active' : ''}" data-view="${v.key}" title="${title}">${v.icon}</button>`;
  }).join('')}</div>`;
}

// (C1395) Live title refresh for the 'sprint' switcher button once the project fetch
// resolves after initial render (see renderViewSwitcher()'s comment above).
export function updateViewSwitcherLabel(groupLabelSingular) {
  const btn = document.querySelector('.view-switcher-btn[data-view="sprint"]');
  if (btn) btn.title = `${groupLabelSingular} Board`;
}

export function bindViewSwitcher(onChange) {
  document.querySelectorAll('.view-switcher-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.view-switcher-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      onChange(btn.dataset.view);
    });
  });
}

export function getViewPref(projectId) {
  // Validate on read — a stale 'list' value (view mode removed in C1166
  // follow-up) or any other unknown value falls back to 'sprint' instead of
  // landing on renderActiveView()'s default case with no highlighted button.
  const v = localStorage.getItem('view-pref-' + projectId);
  return v === 'kanban' ? v : 'sprint';
}

export function setViewPref(projectId, view) {
  localStorage.setItem('view-pref-' + projectId, view);
}
